import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { PfGeo } from "../../models/contract-resource.model";
import { HrRepository } from "../../repositories/hr.repository";

export class RetrievePfGeosUseCase implements UseCase<null, PfGeo[]> {
  constructor(private repo: HrRepository) {}
  execute(): Observable<PfGeo[]> {
    return this.repo.retrieveAllPfGeos();
  }
}

const retrievePfGeosUseCaseFactory = (repo: HrRepository) =>
  new RetrievePfGeosUseCase(repo);
export const retrievePfGeosUseCaseProvider: Provider = {
  provide: RetrievePfGeosUseCase,
  useFactory: retrievePfGeosUseCaseFactory,
  deps: [HrRepository],
};
